import { BRAND } from './brand';

export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? '/api',
  appName: import.meta.env.VITE_APP_NAME ?? BRAND.name,
} as const;

/** Absolute API base for axios, webhooks, and file URLs (works in browser and Electron file://). */
export function getApiBaseUrl(): string {
  const configured = env.apiUrl.replace(/\/$/, '');
  if (configured.startsWith('http://') || configured.startsWith('https://')) {
    return configured;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${configured.startsWith('/') ? configured : `/${configured}`}`;
  }
  return configured;
}
